import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import {
  Table,
  Dropdown,
  Modal,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
function Faq() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
 
  const [addStatus, setAddStatus] = useState(false);
  const [removeFaq, setRemoveFaq] = useState(false);
  const [spinner, setSpinner] = useState(true);
  
  const [faq, setFaq] = useState([]);
  const [faqQuestionId, setFaqQuestionId] = useState('');

  const searchObject = ["Rider", "Onboard", "Customer"];
  const [to, setTo] = useState("Rider");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [qstAns, setQstAns] = useState([]);
  const [faqCategoryId, setFaqCategoryId] = useState('');
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function getAllPricing() {
    axios.get(Baseurl.baseurl + "/go-ui/get-all-faq").then((response) => {
      if(response.data.FAQdetails){
        setFaq(response.data.FAQdetails);
      }
     
      setSpinner(false);
    });
  }
  useEffect(() => {
    getAllPricing();
  }, []);
  const deleteParticularFaq = () => {
    let faqData={
      qaId:faqQuestionId
    }
    axios
      .put(Baseurl.baseurl + `/go-ui/remove-faq/${faqCategoryId}`,faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getAllPricing();
        setShow1(false);
      });
  };
  const deleteFaqCategory = () => {
    axios({
      method: "delete",
      url: Baseurl.baseurl + `/go-ui/delete-faq/${faqCategoryId}`,
      headers: {},
    }).then((response) => {
      if (response.data.status) {
        swal("Deleted", response.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
      } else {
        swal("Oops", response.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }
      getAllPricing();
      setShow1(false);
    });
  };

  function addQstAns() {
    const faq = {
      Question: question,
      Answer: answer,
    };
    setQstAns(
      (oldArray) => oldArray.concat(faq),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
    setQuestion("");
    setAnswer("");
  }
  function addFaq() {
    let faqData = {
      category: to,
      faq: qstAns,
    };
    axios
      .post(Baseurl.baseurl + `/go-ui/create-faq`, faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow(false);
        getAllPricing();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function addFaqToCategory(){
    let faqData = {
      data: qstAns,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/add-faq/${faqCategoryId}`, faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow(false);
        getAllPricing();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateQuestionAnswer(){
    let faqData = {
      question: question,
      answer:answer,
      qaId:faqQuestionId
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/update-faq/${faqCategoryId}`, faqData)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", { timer: 1000 });
        } else {
          swal("Ooops", response.data.message, "error", { timer: 1000 });
        }
        setShow2(false);
        getAllPricing();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <div className="col-16">
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body>
          {removeFaq ? (
            <h4>are you sure! want to delete Faq Questions</h4>
          ) : (
            <h4>are you sure! want to delete this Category</h4>
          )}
        </Modal.Body>
        <Modal.Footer>
          {removeFaq ? (
            <Button variant="primary" onClick={deleteParticularFaq}>
              Delete
            </Button>
          ) : (
            <Button variant="primary" onClick={deleteFaqCategory}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Body>
        <div className=" mb-3">
            <label>Question</label>
            <input
              value={question}
              type="text"
              className="form-control"
              placeholder="enter Question"
              onChange={(e) => {
                setQuestion(e.target.value);
              }}
            />
          </div>

          <div className=" mb-3">
            <label>Answer</label>
            <input
              value={answer}
              type="text"
              className="form-control"
              placeholder="enter Answer"
              onChange={(e) => {
                setAnswer(e.target.value);
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
       <button onClick={()=>{updateQuestionAnswer()}} className="btn btn-primary">
          Update
       </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {!addStatus&&(
             <div className=" mb-3">
             <label>To</label>
 
             <select
               className="form- col-sm-12 text-primary p-2"
               id="val-skill"
               name="val-skill"
               placeholder="Select Search Item"
               defaultValue={to}
               onChange={(event) => {
                 setTo(event.target.value);
               }}
             >
               {searchObject &&
                 searchObject.map((val) => <option value={val}>{val}</option>)}
             </select>
           </div>
          )}
         
          <div className=" mb-3">
            <label>Question</label>
            <input
              value={question}
              type="text"
              className="form-control"
              placeholder="enter Question"
              onChange={(e) => {
                setQuestion(e.target.value);
              }}
            />
          </div>

          <div className=" mb-3">
            <label>Answer</label>
            <input
              value={answer}
              type="text"
              className="form-control"
              placeholder="enter Answer"
              onChange={(e) => {
                setAnswer(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              addQstAns();
            }}
            className="btn btn-primary float-right mt-3"
          >
            Add
          </button>

          {qstAns.length !== 0 && (
            <Table responsive id="myTable">
              <thead>
                <tr>
                  <th>
                    <strong>Question</strong>
                  </th>
                  <th>
                    <strong>Answer</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <tr> */}
                {qstAns &&
                  qstAns.map((val) => (
                    <tr>
                      <td>{val.Question}</td>
                      <td>{val.Answer}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          {qstAns.length !== 0 &&!addStatus&& (
            <Button
              variant="primary"
              onClick={() => {
                addFaq();
              }}
            >
              Add FAQ
            </Button>
          )}
          {qstAns.length !== 0&&addStatus&&( <Button
              variant="primary"
              onClick={() => {
                addFaqToCategory();
              }}
            >
              Update FAQ
            </Button>)}
        </Modal.Footer>
      </Modal>

      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <h4 className="card-title text-white"></h4>
          <button
            onClick={() => {
              setAddStatus(false);
              setShow(true);
              setQstAns([])
            }}
            className="btn btn-primary"
          >
            Add FAQ
          </button>
        </div>
        <div className="card-body">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table responsive id="myTable" className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong>SLNO.</strong>
                  </th>
                  <th>
                    <strong> Category</strong>
                  </th>
                  <th>
                    <strong>FAQ's</strong>
                  </th>

                  <th>
                    <strong></strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {faq.map((p, i) => (
                  <tr key={p._id}>
                    <td>{i + 1}</td>
                    <td>{p.Category}</td>
                    {p.FAQ.map((g) => {
                      return (
                        <>  
                          <Table className="text-white ">
                            <th>
                              <strong>Question</strong>
                            </th>
                            <th>
                              <strong>Answer</strong>
                            </th>
                            <th></th>
                            <tbody>
                              <tr>
                                <td>{g.Question}</td>
                                <td> {g.Answer}</td>

                                <td>
                                  {" "}
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="warning"
                                      className="light sharp i-false"
                                    >
                                      {svg1}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                         setShow2(true)
                                         setQuestion(g.Question)
                                         setAnswer(g.Answer)
                                         setFaqQuestionId(g._id);
                                         setFaqCategoryId(p._id);
                                        }}
                                      >
                                        Update
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        onClick={() => {
                                          setShow1(true);
                                          setRemoveFaq(true);
                                          setFaqQuestionId(g._id);
                                          setFaqCategoryId(p._id);
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>

                                <br />
                              </tr>
                            </tbody>
                          </Table>
                        </>
                      );
                    })}
                    <td className="ml-5">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="warning"
                          className="light sharp i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setAddStatus(true);
                              setShow(true)
                              setFaqCategoryId(p._id);
                            }}
                          >
                            Add Faq
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              setShow1(true);
                              setRemoveFaq(false);
                              setFaqCategoryId(p._id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {faq.length===0 && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              No Faq
            </Alert>
          )}
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">...</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button type="button" class="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
